import { Component, computed, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { CustomPageBlockComponent } from './custom-page-block.component';

/**
 * Display an embedded Google Form.
 */
@Component({
  selector: 'app-custom-page-google-form',
  template: `@if (url()) {
    <div class="mx-auto w-full px-8">
      <iframe
        class="w-full h-screen"
        [src]="url()"
        sandbox="allow-scripts allow-forms allow-same-origin"
        marginheight="0"
        marginwidth="0"
        style="border: none; min-height: 600px"
      >
        Loading…
      </iframe>
    </div>
  }`,
  standalone: true,
})
export class CustomPageGoogleFormComponent extends CustomPageBlockComponent<'google_form_block'> {
  #sanitizer = inject(DomSanitizer);

  protected url = computed(() => {
    const formId = this.data().formId;
    if (!formId) {
      return null;
    }
    return this.#sanitizer.bypassSecurityTrustResourceUrl(
      `https://docs.google.com/forms/d/e/${formId}/viewform?embedded=true`,
    );
  });
}
